export default {
	SettingSystem: {}
};
